import EventBus from '@/components/shared/eventbus';
import i18n from '@/lang/lang';
import usersActions from '@/store/modules/users/actions';
import deviceActions from '@/store/modules/device/actions';
import store from '@/store';


// eslint-disable-next-line import/prefer-default-export
export const globalErrorTypes = [
  'CLASS_LIMIT_EXCEEDED',
  'WAITFOR_SERVICES',
  'PERMISSION_DENIED',
  'STUDENT_NOT_FOUND',
  'CLASS_NOT_FOUND',
  'CURRENT_USER_NOT_FOUND',
  'PERMISSION_DENIED',
  'USER_NOT_FOUND',
  'VALIDATION_ERROR',
  'CLASS_NOT_ALLOWED_TO_MODIFY',
  'NOT_ALLOWED_FOR_TEACHER',
  'NOT_ALLOWED_FOR_DKT_USER',
  'NOT_ALLOWED_IN_DKT_CLASS',
  'NOT_SUPPORTED_LANGUAGE',
  'OPERATION_NOT_ALLOWED'
];

export const guestErrorTypes = [
  'CLASS_NOT_FOUND',
  'ASSIGNMENT_NOT_FOUND'
];

const globalErrorTexts = {
  CLASS_LIMIT_EXCEEDED: 'app.general.errors.CLASS_LIMIT_EXCEEDED',
  WAITFOR_SERVICES: 'app.general.errors.WAITFOR_SERVICES',
  VALIDATION_ERROR: 'app.general.errors.VALIDATION_ERROR',
  DKT_VALIDATION_ERROR: 'app.dkt.general.errors.VALIDATION_ERROR',
  CLASS_NOT_ALLOWED_TO_MODIFY: 'app.dkt.general.errors.CLASS_NOT_ALLOWED_TO_MODIFY',
  NOT_ALLOWED_FOR_TEACHER: 'app.dkt.general.errors.NOT_ALLOWED_FOR_TEACHER',
  NOT_ALLOWED_FOR_DKT_USER: 'app.dkt.general.errors.NOT_ALLOWED_FOR_DKT_USER',
  NOT_ALLOWED_IN_DKT_CLASS: 'app.dkt.general.errors.NOT_ALLOWED_IN_DKT_CLASS',
  NOT_SUPPORTED_LANGUAGE: 'app.dkt.general.errors.NOT_SUPPORTED_LANGUAGE',
  OPERATION_NOT_ALLOWED: 'app.dkt.general.errors.OPERATION_NOT_ALLOWED'
};

export const globalErrorHandler = (error) => {
  if (error.response && error.response.data) {
    if (globalErrorTypes.includes(error.response.data.type) && error.response.data.type === 'VALIDATION_ERROR') {
      const user = store.getters.loggedInUserProfile;
      EventBus.closeModal();
      EventBus.showGlobalToast({
        type: 'error',
        text: user && user.provider === 'idp'
          ? i18n.t(globalErrorTexts.DKT_VALIDATION_ERROR)
          : i18n.t(globalErrorTexts.VALIDATION_ERROR)
      });
    } else if (guestErrorTypes.includes(error.response.data.type)) {
      store.commit('settings/SET_GUEST_ERROR', true);
      location.replace('/classes');
    } else if (globalErrorTypes.includes(error.response.data.type)) {
      EventBus.closeModal();
      EventBus.showGlobalToast({
        type: 'error',
        text: globalErrorTexts[error.response.data.type]
          ? i18n.t(globalErrorTexts[error.response.data.type])
          : error.response.data.type
      });
    } else if (error.response.data.type === 'INVALID_TOKEN' || error.response.data.code === 401) {
      if (store.getters['settings/getHandledUnauthorizedError'] !== true) {
        const user = store.getters['users/getLoggedInUserProfile'];
        const isKretaUser = user && user.provider === 'idp';
        if (!location.pathname.split('/')[1].includes('dkt') && user) {
          usersActions.logout();
          if (isKretaUser) {
            store.commit('settings/SET_SESSION_EXPIRED', true);
            location.href = '/users/login';
          } else {
            location.href = '/';
          }
        } else if (!location.pathname.split('/')[1].includes('dkt') && user === undefined) {
          location.href = '/';
        }
        store.commit('settings/SET_HANDLED_UNAUTHORIZED_ERROR', true);
      }
    }
  }
  return Promise.reject(error);
};



// WEBPACK FOOTER //
// ./src/components/shared/globalErrors.js